<template>
  <span>
    <v-icon v-if="bool" color="successAccent">
      mdi-check
    </v-icon>
    <v-icon v-else color="errorAccent">
      mdi-close
    </v-icon>
  </span>
</template>

<script>
//  TODO: add props to customize true/false representation for warning or extra text

//  const ELEMENT_PROPS = {
//   success: { color: 'successAccent', icon: 'mdi-check' },
//   warning: { color: 'warningAccent', icon: 'mdi-exclamation-thick' },
//   error: { color: 'errorAccent', icon: 'mdi-close' },
// };

export default {
  props: {
    bool: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped></style>
